"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeElapsedMsUnix = exports.timeElapsedMs = void 0;
const timeElapsedMs = (start, end = new Date()) => end.getTime() - start.getTime();
exports.timeElapsedMs = timeElapsedMs;
const timeElapsedMsUnix = (start, end = Date.now()) => end - start;
exports.timeElapsedMsUnix = timeElapsedMsUnix;
//# sourceMappingURL=timeElapsed.js.map